// extracted by mini-css-extract-plugin
export default {"base":"Modal_base__N3ov3","content":"Modal_content__J-8eK","overlay":"Modal_overlay__WsSXA"};